<template>
    <div>
        <div v-for="(barcodeName, barcodeId) in availableBarcodeIds">
            <label>
                <input type="radio"
                       name="barcode_id"
                       :value="barcodeId"
                       :disabled="barcodeName === 'API ERROR'"
                       v-model="selectedBarcodeId"
                >
                {{ barcodeName }}
            </label>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        availableBarcodeIds: Object,
        value: Array
    },

    data() {
        return {
            selectedBarcodeId: null
        }
    },

    mounted() {
        if (this.value && this.value.length > 0) {
            this.selectedBarcodeId = this.value[0]
        }
    },

    watch: {
        selectedBarcodeId(newValue, oldValue) {
            this.$emit('input', [parseInt(newValue)]);
        }
    }
}
</script>
